import React from 'react';
import {useTranslation} from 'react-i18next';
import Button, {ButtonStyles} from 'components/common/Form/Button';
import style from 'components/Page/Header/UserMenu/UserMenu.module.scss';

export default function UserMenu({logout}) {
    const {t} = useTranslation();

    return (
        <div className={style.userMenuWrapper}>
            <Button
                text={t(`page.logout`)}
                onClick={logout}
                btnStyle={ButtonStyles.secondary}
                className={style.button}
            />
        </div>
    );
}
